import { useSyncExternalStore } from 'react';
import { resolvePrototypeEnabled } from './prototypeFlag';
import {
  getPrototypeOverride,
  subscribePrototypeOverride,
} from './prototypeOverride';

export { resolvePrototypeEnabled } from './prototypeFlag';

export const isPrototypeEnabled = resolvePrototypeEnabled(
  import.meta.env.SEATERS_PROTOTYPE_ENABLED,
  import.meta.env.MODE
);

/**
 * The build-time flag combined with the session-scoped runtime override.
 * `false` whenever the build disables prototype mode OR the override disables
 * it (`?prototype=off`), so every gate below collapses to production behaviour.
 */
export function getEffectivePrototypeEnabled(): boolean {
  return isPrototypeEnabled && getPrototypeOverride() !== 'disabled';
}

function getPrototypeEnabled() {
  return getEffectivePrototypeEnabled();
}

/**
 * Backwards-compatible plain reader (despite the `use` name it is not a hook):
 * it reads the effective value at call time but does not subscribe. Prefer
 * {@link useEffectivePrototypeEnabled} in components that must re-render when a
 * runtime override changes.
 */
export const usePrototype = getPrototypeEnabled;

/**
 * React-friendly reader that re-renders when the runtime override changes.
 * Use inside components; `getEffectivePrototypeEnabled()` for plain code.
 */
export function useEffectivePrototypeEnabled(): boolean {
  return useSyncExternalStore(
    subscribePrototypeOverride,
    getEffectivePrototypeEnabled,
    getEffectivePrototypeEnabled
  );
}
